export default __webpack_public_path__ + "static/media/treat.26f33ebb.svg";